import { Palette, PaletteColor } from "@mui/material";
import { EtaStatus, Status } from "../../../graphql/generated";
import { shipmentStatusColors } from "../../shipment/ShipmentsList/ShipmentsList";

export const etaStatusPaletteColor: Record<
  EtaStatus,
  "success" | "warning" | "error"
> = {
  [EtaStatus.OnTime]: "success",
  [EtaStatus.AtRisk]: "warning",
  [EtaStatus.Delayed]: "error",
  [EtaStatus.TooEarly]: "warning",
};

export type TripLiveEtaDisplayFields = {
  etaStatus?: EtaStatus | null;
  nextStopName?: string | null;
  etaToNextStopMinutes?: number | null;
  etaToDeliveryMinutes?: number | null;
};

export function formatEtaMinutes(
  minutes: number | null | undefined,
): string {
  if (minutes == null) {
    return "";
  }
  return `${minutes} min`;
}

export function hasLiveEtaDisplay(
  trip: TripLiveEtaDisplayFields | null | undefined,
): boolean {
  if (!trip) {
    return false;
  }
  return (
    Boolean(trip.etaStatus) ||
    Boolean(trip.nextStopName) ||
    trip.etaToNextStopMinutes != null ||
    trip.etaToDeliveryMinutes != null
  );
}

export function getSchedulerBarColor(
  etaStatus: EtaStatus | null | undefined,
  hasViolations: boolean,
  status: Status,
  palette: Palette,
): string {
  const statusColor =
    (
      palette[shipmentStatusColors[status] as keyof Palette] as PaletteColor
    )?.main ?? palette.primary.main;

  if (status === Status.Assigned) {
    return statusColor;
  }
  if (etaStatus === EtaStatus.OnTime && status === Status.InProgress) {
    return statusColor;
  }
  if (etaStatus && etaStatusPaletteColor[etaStatus]) {
    return (palette[etaStatusPaletteColor[etaStatus]] as PaletteColor).main;
  }
  if (hasViolations) {
    return palette.warning.main;
  }
  return statusColor;
}
